import { APIModel, APIModelImpl } from '../../../toolkit/uicomponentapimodel';
import { ToneDto } from '../../../../core/dto/tonedto';
import { AddToWishlistDtoImpl } from '../../../../core/dto/wishlist/addtowishlist/addtowishlistdto';
import { AddToWishlistResponse } from '../../../../core/api/wishlist/addtowishlist/addtowishlistresponse';
import { AddToWishlistRequestImpl } from '../../../../core/api/wishlist/addtowishlist/addtowishlistrequest';
import { ToneOptionsType } from '../../popup/tonedetailspopup/tonedetailspopupcomponent';

export interface ToneOptionAPIModel extends APIModel
{
    addToWishlist(toneDto: ToneDto, type: ToneOptionsType): void;
}

export class ToneOptionAPIModelImpl extends APIModelImpl implements ToneOptionAPIModel
{
     addToWishlist(toneDto: ToneDto, type: ToneOptionsType): void 
     { 
             let addToWishlistDto = new AddToWishlistDtoImpl();
             addToWishlistDto.setMsisdn(this.getContext().getUserContext().getMsisdn());
             addToWishlistDto.setLanguage(this.getContext().getUserContext().getLanguage());
             addToWishlistDto.setIdentifier("AddToWishList");
             addToWishlistDto.setContentId(type=== ToneOptionsType.TONE ? toneDto.getId() : toneDto.getContentId().split("|")[0]);
             addToWishlistDto.setContentName(toneDto.getToneName());
             addToWishlistDto.setPath(toneDto.getToneUrl());
             addToWishlistDto.setPreviewImage(toneDto.getImgPath());
             addToWishlistDto.setAlbum(toneDto.getAlbumName());
             addToWishlistDto.setArtist(toneDto.getArtistName());
             addToWishlistDto.setPrice(String(toneDto.getPrice()));
             addToWishlistDto.setWishlistType("1");
    
             this.getAPIProcesssorFactory().getToneProcessorFactory()
             .getAddToWishlist()
             .success((addToWishlistResponse: AddToWishlistResponse)=>
             {
                 this.getAPIModelHandler().onSuccess(addToWishlistResponse.getAPIFeature(), 
                 addToWishlistResponse.getDescription(), addToWishlistResponse);
               
              })
             .failure((addToWishlistResponse: AddToWishlistResponse)=>
              {
                this.getAPIModelHandler().onFailure(addToWishlistResponse.getAPIFeature(), 
                addToWishlistResponse.getDescription(), undefined);
              })
             .execute(new AddToWishlistRequestImpl(addToWishlistDto));
     } 
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/toneoption/toneoptionapimodel.tsx